import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { confirmPreviews } from "reducers/Confirm";
import { deleteCreativePreview } from "reducers/CreativePreviews";
import { Button } from "rhombus-react";
import { pluralize } from "utils/common";

export default function BulkDeletePreviewsButton({ previews, disabled }) {
	const dispatch = useDispatch();
	const { libraryId } = useSelector(state => ({
		libraryId: state.libraryProperties.id,
	}));

	const plural = pluralize("", previews.length);
	const confirmProps = {
		libraryId,
		previews,
		title: `Delete Preview${plural}`,
		desc: `Are you sure you want to delete the following shared preview${plural}?`,
		commitTheme: "red",
	};


	const handleClick = () => {
		return dispatch(confirmPreviews(deleteCreativePreview, confirmProps));
	};

	return (
		<Button
			style="block"
			icon="fas fa-trash-alt"
			theme="blue"
			onClick={handleClick}
			disabled={disabled}
		>
			Delete
		</Button>
	);
}
